export class GreentaxSlab {
  public GREENTAX_ID!: Number;
  public FROM_LOC!: Number;
  public TO_LOC!: Number;
  public CALCULATE_ON!: string;
  public FROM_SLAB!: Number;
  public TO_SLAB!: Number;
  public GREENTAX_AMOUNT!: number;
  public CREATEDBY_USERID!: Number;
  public UPDATEDBY_USERID!: Number;
  public CREATED_DATE!: Date;
  public UPDATED_DATE!: Date;
  public IS_ACTIVE!: number;
}
